import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.png";
import Particle from "../Particle";
import Type from "./Type";
import { AiFillInstagram,} from "react-icons/ai";
import { BsTwitterX } from "react-icons/bs";
import { FaDiscord } from "react-icons/fa";
import { SiPatreon } from "react-icons/si";

function Home() {
  return (
    <>
      <Particle />
      <Container fluid className="home-section">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">

              <h1 className="heading-name">
                Welcome to <strong className="main-name"> Chonkbox Studios</strong>
              </h1>

              <h3 style={{ paddingBottom: 15 }} className="heading">
                Big ideas in a small box{" "}
              </h3>

              <div style={{ textAlign: "left", textWrap: "nowrap" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ marginTop: 50, display: "flex", justifyContent: "center", alignItems: "center" }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>

      <Container>
        <Row style={{ paddingTop: "50px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social">
            <h1>Find Us On</h1>
            <p>
              Feel free to <span className="cyan">connect </span>with us
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://x.com/Chonkbox"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <BsTwitterX />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/Chonkbox"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://discord.gg/t4U6mkK5wC"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaDiscord />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://patreon.com/chonkbox"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <SiPatreon />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Home;
